import { SvgIcon } from '@material-ui/core';
import React from 'react';

export const Forklift = props => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path
			d="M6,4V11H4C2.89,11 2,11.89 2,13V17A3,3 0 0,0 5,20A3,3 0 0,0 8,17H10A3,3 0 0,0 13,20A3,3 0 0,0 16,
              17V13L12,4H6M17,5V19H22V17.5H18.5V5H17M7.5,5.5H11.2L14.5,13H7.5V5.5M5,15.5A1.5,1.5 0 0,1 6.5,17A1.5,
              1.5 0 0,1 5,18.5A1.5,1.5 0 0,1 3.5,17A1.5,1.5 0 0,1 5,15.5M13,15.5A1.5,1.5 0 0,1 14.5,17A1.5,1.5 0 0,1 13,
              18.5A1.5,1.5 0 0,1 11.5,17A1.5,1.5 0 0,1 13,15.5Z"
		/>
	</SvgIcon>
);

export const Agent = props => (
	<SvgIcon {...props}>
		<path
			d="M7,17H4C2.38,17 0.96,15.74 0.76,14.14L0.26,11.15C0.15,10.3 0.39,9.5 0.91,8.92C1.43,8.34 2.19,8 3,
              8H9C9.83,8 10.58,8.35 11.06,8.96C11.17,9.11 11.27,9.27 11.35,9.45C11.78,9.36 12.22,9.36 12.64,
              9.45C12.72,9.27 12.82,9.11 12.94,8.96C13.41,8.35 14.16,8 15,8H21C21.81,8 22.57,8.34 23.09,8.92C23.6,
              9.5 23.84,10.3 23.74,11.11L23.23,14.18C23.04,15.74 21.61,17 20,17H17C15.44,17 13.92,15.81 13.54,
              14.3L12.64,11.59C12.26,11.31 11.73,11.31 11.35,11.59L10.43,14.37C10.07,15.82 8.56,17 7,17Z"
		/>
	</SvgIcon>
);

export const Customer = props => (
	<SvgIcon {...props}>
		<path
			d="M4,16H7V22H4V16M19,2.39C18.92,3.86 18.55,5.13 17.86,6.21C17.17,7.29 16.22,8 15,
              8.39V22H13V16H11V22H9V10.08C8.72,10.17 8.5,10.28 8.39,10.41C7.45,11.16 7,12.19 7,13.5V14H5V13.5C5,
              11.53 5.72,9.94 7.13,8.72C8.53,7.56 10.16,7 12,7C13.41,7 14.56,6.64 15.47,5.95C16.5,5.11 17,3.95 17,
              2.5V2H19V2.39M12,2A2,2 0 0,1 14,4A2,2 0 0,1 12,6A2,2 0 0,1 10,4A2,2 0 0,1 12,2Z"
		/>
	</SvgIcon>
);

export const Logo = props => (
	<SvgIcon {...props} viewBox="0 0 3321 883.03">
		<title>WH+</title>
		<polygon
			points="3100.64 337.67 3051.18 337.67 3051.18 288.21 3001.72 288.21 3001.72 337.67 2952.26 337.67
                 2952.26 387.13 3001.72 387.13 3001.72 436.59 3051.18 436.59 3051.18 387.13 3100.64 387.13 3100.64
                 337.67"
		/>
		<path
			d="M884.59,337.68h61.49l36.6,121.48,40.49-122.08h50.1l40.49,122.08,36.6-121.48h60.29l-70.19,
              211.47h-50.7l-42.29-120.88-42,120.88H954.78Z"
		/>
		<path
			d="M1264.34,336.18h56.09l89.39,211.47h-62.39l-15.3-37.49h-81l-15,37.49H1175Zm51,129-23.39-59.69-23.7,
              59.69Z"
		/>
		<path
			d="M1430.22,337.68h99.29q24.3,0,41.1,6t27.29,16.79q18.6,18,18.6,48.9v.6q0,24.3-11.7,40.19t-31.49,
              24.3l50.09,73.19h-67.19l-42.3-63.59h-25.5v63.59h-58.19Zm96.59,100.79q15,0,
              23.1-6.75t8.1-18.15V413q0-12.6-8.4-18.75t-23.1-6.15h-38.1v50.4Z"
		/>
		<path d="M1645.9,337.68h168.58v49.49H1703.19V419H1804v45.89H1703.19v33.3H1816v49.49H1645.9Z" />
		<path d="M1846,337.68h58.19v78.59h74.7V337.68h58.19v210h-58.19V467.86h-74.7v79.79H1846Z" />
		<path
			d="M2173.83,551.85a116.64,116.64,0,0,1-45-8.55,110.79,110.79,0,0,1-35.7-23.24,107.38,107.38,0,0,
              1-23.55-34.5,105.55,105.55,0,0,1-8.55-42.3v-.59a107,107,0,0,1,32.4-77.25,113.22,113.22,0,0,1,36-23.39,
              122.67,122.67,0,0,1,90,0,111,111,0,0,1,35.69,23.24,107.38,107.38,0,0,1,23.55,34.5,105.55,105.55,0,0,1,
              8.55,42.3v.6a107,107,0,0,1-32.4,77.24,113.12,113.12,0,0,1-36,23.39A116.72,116.72,0,0,1,2173.83,
              551.85Zm.45-52.49a52.59,52.59,0,0,0,22-4.5,50.45,50.45,0,0,0,16.84-12.15,56.17,56.17,0,0,0,10.83-17.85,
              59.68,59.68,0,0,0,3.92-21.6v-.59a59.76,59.76,0,0,0-3.92-21.6,55.37,55.37,0,0,0-11.13-18,54.66,54.66,0,0,
              0-17.14-12.45,54.64,54.64,0,0,0-43.77-.15,52.26,52.26,0,0,0-27.67,30,61.87,61.87,0,0,0-3.76,21.6v.6a59.66,
              59.66,0,0,0,3.91,21.59,56.56,56.56,0,0,0,11,18,52.91,52.91,0,0,0,17,12.45A51.14,51.14,0,0,0,2174.28,
              499.36Z"
		/>
		<path
			d="M2406,551.55q-22.5,0-40.49-5.7a78.39,78.39,0,0,
              1-30.6-17.54q-12.6-11.85-19.35-30t-6.75-42.75V337.68h59.4V454.36q0,22.8,10.41,33.75t28,10.95q17.57,0,
              28-10.5t10.42-32.7V337.68h59.39V454.06q0,25.5-7,43.95t-19.79,30.3a79.67,79.67,0,0,1-30.9,17.54Q2428.5,
              551.55,2406,551.55Z"
		/>
		<path
			d="M2621.38,551.25a163.05,163.05,0,0,1-53.55-8.75A129.7,129.7,0,0,1,2523,516.24l32.39-38.78q31.5,25.2,
              68.1,25.2,11.7,0,17.85-3.74a11.8,11.8,0,0,0,6.14-10.64v-.59a11.28,11.28,0,0,0-1.5-5.84,15.2,15.2,0,0,
              0-5.55-4.94,57.18,57.18,0,0,0-10.79-4.64q-6.75-2.25-17.55-4.65-16.8-3.89-31.2-8.53a95.14,95.14,0,0,
              1-25.05-12A54.13,54.13,0,0,1,2539,428.85q-6.15-10.94-6.15-27.1v-.6a64.53,64.53,0,0,1,5.55-26.95,59.68,
              59.68,0,0,1,16.19-21.26A76.2,76.2,0,0,1,2580.28,339a108.21,108.21,0,0,1,33.9-4.94q27,0,48.14,7.09a121.56,
              121.56,0,0,1,38.25,21l-29.1,41.22a118.07,118.07,0,0,0-29.54-15.45,89.42,89.42,0,0,0-29.25-5.25q-10.5,
              0-15.75,3.9t-5.25,9.58v.6a11.77,11.77,0,0,0,1.65,6.28,15,15,0,0,0,5.7,5,63,63,0,0,0,11.1,4.49q7,2.25,
              17.85,4.64a256.15,256.15,0,0,1,32.54,9.13A97.31,97.31,0,0,1,2685.27,439a51,51,0,0,1,15.6,18.11q5.4,10.64,
              5.4,25.3v.6q0,16.17-6.15,28.75a61.76,61.76,0,0,1-17.25,21.41,78,78,0,0,1-26.7,13.47A121.6,121.6,0,0,1,
              2621.38,551.25Z"
		/>
		<path d="M2734.46,337.68H2903v49.49H2791.76V419h100.78v45.89H2791.76v33.3h112.78v49.49H2734.46Z" />
		<polygon
			points="737.08 221.24 663.38 221.24 663.38 147.54 589.69 147.54 589.69 221.24 516 221.24 516 294.93
                 589.69 294.93 589.69 368.62 663.38 368.62 663.38 294.93 737.08 294.93 737.08 221.24"
		/>
		<polygon
			points="589.69 442.32 589.69 589.7 294.92 589.7 294.92 294.93 442.31 294.93 442.31 221.24 294.92
                 221.24 221.23 221.24 221.23 294.93 221.23 589.7 221.23 663.39 294.92 663.39 589.69 663.39 663.38
                 663.39 663.38 589.7 663.38 442.32 589.69 442.32"
		/>
	</SvgIcon>
);

export const Marker = props => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path
			d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,
              7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"
		/>
	</SvgIcon>
);

export const Pickup = props => (
	<SvgIcon {...props} viewBox="0 0 512 512">
		<path d="M511.926,138.298c-0.023-0.708-0.253-1.387-0.422-2.091c-0.169-0.695-0.271-1.398-0.569-2.033    c-0.055-0.117-0.042-0.246-0.102-0.362l-43.635-85.333c-1.823-3.573-5.49-5.813-9.5-5.813H224.969c-4.01,0-7.677,2.24-9.5,5.813    l-43.635,85.333c-0.06,0.116-0.047,0.245-0.102,0.362c-0.298,0.634-0.4,1.337-0.569,2.033c-0.169,0.704-0.398,1.383-0.422,2.091    c-0.005,0.13-0.074,0.237-0.074,0.369v128.383c-19.362,1.137-36.335,4.958-46.619,7.788    c-3.212-11.169-12.328-20.174-24.413-22.587L12.76,234.875c-3.125-0.583-6.385,0.188-8.854,2.208    C1.438,239.115,0,242.135,0,245.333V416c0,5.896,4.771,10.667,10.667,10.667H77.5c13.165,0,24.384-8.382,29.212-20.147    c23.875,11.383,134.342,62.814,181.288,62.814c41.375,0,126.531-41.865,182.875-69.563c14.708-7.229,26.865-13.208,34.75-16.667    c3.875-1.708,6.375-5.542,6.375-9.771V138.667C512,138.535,511.931,138.428,511.926,138.298z M103.917,285.135L88.052,396.177    c-0.74,5.219-5.281,9.156-10.552,9.156H21.333v-146.99l74.115,14.823C101,274.281,104.719,279.531,103.917,285.135z M451.177,64    l32.721,64H402.99l-16-64H451.177z M317.656,64h47.354l15.996,64H301.66L317.656,64z M298.667,149.333H384V192h-85.333V149.333z     M231.49,64h64.188l-16,64h-80.909L231.49,64z M461.458,380.625C410.208,405.823,324.417,448,288,448    c-38.802,0-140.688-45.427-176.667-62.927c-0.043-0.021-0.09-0.014-0.133-0.034l12.557-87.898    c7.759-2.43,31.513-9.141,57.576-9.141c15.75,0,27.906,5.865,43.292,13.281c13.813,6.667,29.479,14.219,50.583,18.51    c46.354,9.396,66.125,19.031,66.125,32.208c0,2.604-0.792,4.208-2.823,5.719c-6.75,5.052-33.24,13.594-132.813-15.948    c-5.667-1.646-11.583,1.563-13.26,7.198c-1.677,5.646,1.552,11.583,7.198,13.26c49.125,14.563,86.698,21.823,113.323,21.823    c17.365,0,30.073-3.083,38.313-9.24c0.711-0.53,1.232-1.18,1.878-1.751c0.665-0.073,1.322,0.008,1.987-0.197    C374,367.063,427.438,352,448,352c17.396,0,35.698,5.292,41.094,15.208C481.646,370.708,472.219,375.344,461.458,380.625z     M490.667,340.706c-11.02-6.286-25.576-10.039-42.667-10.039c-20.822,0-64.004,11.603-85.885,17.889    c-2.902-30.612-42.124-41.448-82.656-49.681c-18.5-3.75-32.26-10.385-45.573-16.802c-13.419-6.479-26.389-12.422-41.885-14.462    V149.333h85.333v53.333c0,5.896,4.771,10.667,10.667,10.667h106.667c5.896,0,10.667-4.771,10.667-10.667v-53.333h85.333V340.706z" />
	</SvgIcon>
);

export const GroupBy = props => (
	<SvgIcon {...props} viewBox="0 0 419 512" fill="none" style={{ width: '18px', height: '18px' }}>
		<path
			xmlns="http://www.w3.org/2000/svg"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M77.6679 2.14542C71.2259 5.33355 67.9999 10.7891 67.9999 18.495C67.9999 26.2599 71.2549 31.7264 77.7499 34.8696L82.1309 36.99H209.5H336.869L341.25 34.8696C347.745 31.7264 351 26.2599 351 18.495C351 10.7301 347.745 5.26357 341.25 2.12043L336.869 0L209.434 0.000999729L81.9999 0.00199946L77.6679 2.14542ZM46.7229 70.1C42.1839 72.3454 38.2419 77.8579 37.0369 83.6433C35.5309 90.8744 40.4869 99.699 47.9589 103.092C51.8249 104.848 58.8318 104.928 209.5 104.928C360.168 104.928 367.175 104.848 371.041 103.092C378.513 99.699 383.469 90.8744 381.963 83.6433C380.743 77.7839 376.798 72.3034 372.198 70.077L367.869 67.9816L209.434 67.9826L50.9999 67.9836L46.7229 70.1ZM41.7719 137.4C23.0019 141.947 7.95485 156.681 1.83485 176.504C0.0918541 182.154 -0.000144958 189.506 -0.000144958 323.912C-0.000144958 458.396 0.0908557 465.67 1.83886 471.372C7.92986 491.243 23.9029 506.298 43.2429 510.395C53.3439 512.535 365.656 512.535 375.757 510.395C395.097 506.298 411.07 491.243 417.161 471.372C418.909 465.67 419 458.396 419 323.912C419 189.506 418.908 182.154 417.165 176.504C410.892 156.185 394.984 141.051 375.701 137.06C367.533 135.369 48.8129 135.694 41.7719 137.4Z"
			fill="#1da4f2"
		/>
	</SvgIcon>
);
